import { buildConnection } from '$app/arrp-hub-connection-builder'
import apiConnection from '$app/plugins/api-connection'
import defaultPagingInfo from '$app/default-paging-info'

const connection = buildConnection('StagingEnrollment');

// STATE
const state = {
  loading: false,
  nextId: 0,
  pagingInfo: defaultPagingInfo(),
  items: [],
  locks: [],
  totalItems: 0,
  searchModel: {
    fleId: '',
    providerId: '',
    programType: '',
    lastname: '',
    firstName: '',
    reduceToErrors: false,
    reduceToWarnings: false
  },
  itemsToLinkToProvider: []
}

// MUTATIONS
const mutations = {
  updateSearchModel(state, searchModel) {
    state.searchModel = searchModel;
    state.pagingInfo.page = 1;
  },
  updateTotalItems(state, totalItems) {
    state.totalItems = totalItems;
  },
  addItem(state, item) {
    state.items.push(item);
    state.nextId = item.id + 1;
  },
  updateItem(state, item) {
    const idx = state.items.findIndex(x => x.stagingEnrollmentId === item.stagingEnrollmentId);
    if (idx !== -1) {
      state.items.splice(idx, 1, { ...item });
    }
  },
  setLocks(state, locks) {
    state.locks = locks;
  },
  updateItems(state, items) {
    state.items = [...items];
  },
  updatePagingInfo(state, pagingInfo) {
    state.pagingInfo = { ...pagingInfo };
  },
  addItemToLinkToProvider(state, item) {
    state.itemsToLinkToProvider.push(item);
  },
  removeItemToLinkToProvider(state, item) {
    const itemIndex = state.itemsToLinkToProvider.findIndex(i => i.stagingEnrollmentId === item.stagingEnrollmentId);

    if (itemIndex !== -1) {
      state.itemsToLinkToProvider.splice(itemIndex, 1);
    }
  },
  clearItemsToLinkToProviderList(state) {
    state.itemsToLinkToProvider = [];
  },
  setLoading(state, loading) {
    state.loading = loading;
  }
}

// ACTIONS
const actions = ({
  async connect({ commit, dispatch }) {
    connection.onLocksUpdated((locks) => commit('setLocks', locks));
    connection.onEntitiesUpdated(() => dispatch('search'));
    await connection.connect();
  },
  async disconnect() {
    await connection.disconnect();
  },
  lockItem({ commit }, item) {
    connection.lockById(item.stagingEnrollmentId);
  },
  unlockItem({ commit }, item) {
    connection.unlockById(item.stagingEnrollmentId);
  },
  search({ commit, state }) {
    const searchModel = { ...state.searchModel, pagingInfo: state.pagingInfo };
    commit('setLoading', true);
    apiConnection.post('api/arrp/searchstagedenrollments', searchModel).then(resp => {
      const items = resp.data.items.map(e => ({ ...e, errors: e.rowErrors, warnings: e.rowWarnings }));

      commit('updateItems', items);
      commit('updateTotalItems', resp.data.totalItems);
    }).finally(() => commit('setLoading', false));
  },
  itemAdded({ dispatch }, item) {
    apiConnection.post('api/arrp/saveStagedEnrollment', { ...item }).then(resp => {
      dispatch('search');
    });
  },
  itemEdited({ dispatch }, item) {
    apiConnection.post('api/arrp/saveStagedEnrollment', { ...item }).then(resp => {
      dispatch('search');
    });
  },
  deleteItem({ dispatch }, item) {
    var id = item.stagingEnrollmentId;
    apiConnection.delete('api/arrp/deleteStagedEnrollment?enrollmentId=' + id);
  },
  sortItems({ commit, dispatch }, sortValues) {
    const pInfo = { ...state.pagingInfo, page: 1, ...sortValues };
    commit('updatePagingInfo', pInfo);
    dispatch('search');
  },
  pagingInfoUpdated({ commit, dispatch }, pagingInfo) {
    commit('updatePagingInfo', pagingInfo);
    dispatch('search');
  },
  getPagedData({ commit, dispatch, state }, page) {
    commit('updatePagingInfo', { ...state.pagingInfo, page });
    dispatch('search');
  },
  itemAddedToLinkToProviderList({ commit, dispatch, state }, item) {
    var enrollmentExists = [...state.itemsToLinkToProvider].filter(e => e.stagingEnrollmentId === item.stagingEnrollmentId).length > 0;

    if (!enrollmentExists) {
      dispatch('lockItem', item);
      commit('addItemToLinkToProvider', item);
    }
  },
  itemRemovedFromLinkToProviderList({ commit, dispatch }, item) {
    dispatch('unlockItem', item);
    commit('removeItemToLinkToProvider', item);
  },
  clearLinkToProviderList({ commit, dispatch, state }) {
    const itemsToUnlock = state.itemsToLinkToProvider.map(item => ({ ...item }));
    itemsToUnlock.forEach(item => dispatch('unlockItem', item));
    commit('clearItemsToLinkToProviderList');
  },
  saveEnrollmentProviderLinks({ state }, provider) {
    return new Promise((resolve, reject) => {
      const data = {
        enrollments: [...state.itemsToLinkToProvider],
        provider
      };

      apiConnection.post('api/arrp/linkStagedEnrollmentsToProviders', data, {
        headers: { 'Content-Type': 'application/json' }
      }).then(response => {
        resolve(response);
      }, error => {
        reject(error.response.data);
      })
    });
  }
});

// GETTERS
const getters = {
  searchModel: state => state.searchModel,
  itemsToLinkToProvider: state => state.itemsToLinkToProvider,
  currentPage: state => state.items.map(item => ({ ...item, locked: state.locks.includes(item.stagingEnrollmentId) }))
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
